import {
  ColumnMeta,
  FilterResultMethod,
  MetaValueType,
} from '@api/api/screener';
import { formatPercentage } from '@helpers/utils/numbers/numbers';

const numFormatter = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const priceFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const mapValueTypeToFormatter: Record<
  MetaValueType,
  (value: number) => string
> = {
  float: value => priceFormatter.format(value),
  scaled_number: value => numFormatter.format(value),
  integer: value => value.toString(),
};

export const isScreenerPercentageColumn = (name?: string): boolean => {
  const isRealizedVolatility = name?.includes('Realized Volatility');
  return !!name?.includes('%') && !isRealizedVolatility;
};

export const formatScreenerCellValue = (
  { value, units }: FilterResultMethod,
  columnMeta: Pick<ColumnMeta, 'name' | 'value_type'>
): string => {
  if (value === undefined) {
    return '-';
  }

  if (isScreenerPercentageColumn(columnMeta.name)) {
    return formatPercentage(value, {
      useOriginalValue: true,
      addPlus: true,
      suffix: '',
    });
  }

  const formatter = mapValueTypeToFormatter[columnMeta.value_type ?? 'integer'];
  const formatted = formatter(value);

  return units ? `${formatted}${units.toUpperCase()}` : formatted;
};

export const formatWatchlistPrice = (price: number): string =>
  priceFormatter.format(price);

export const formatWatchlistReturn = ({
  value,
  formattedValue,
}: {
  value?: number;
  formattedValue?: string;
}): string => {
  if (formattedValue) {
    return formattedValue;
  }

  if (value === undefined) {
    return '-';
  }

  return formatPercentage(value, {
    useOriginalValue: true,
    addPlus: true,
    suffix: '',
  });
};
